import { html } from 'lit';
import { Maximize2 } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-maximize')
export class PdsIconMaximize extends PdsIcon {
  @state()
  icon = Maximize2;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
